/* eslint-disable */
/* global $ document window Tether */
import intl from 'react-intl-universal'

import template from './template.html'
import typographyButtons from './buttons'
import charMapOpts from './charMapOpts.json'
import {
  extractSelectedText,
  insertNodeIntoCursorPosition,
  selectNode,
} from '~/util/documentSelection'
import { constants } from '../contenteditablebind/directive'
import { normaliseSelectionRange } from '../composeBody/copypaste'

export default [directive]

function directive() {
  return {
    restrict: 'E',
    replace: true,
    template,
    link: function ($scope, elem, attr) {},
    controller: [
      '$scope',
      '$rootScope',
      'tabService',
      '$ngRedux',
      'toastr',
      'storyService',
      Controller,
    ],
  }
}

const createInlineCommentNode = () => {
  const dfnNode = document.createElement('dfn')
  dfnNode.innerHTML = '&nbsp;'
  const spanNode = document.createElement('span')
  spanNode.appendChild(dfnNode)
  spanNode.innerHTML += '&nbsp;'
  return spanNode
}

// Return an object made out of global state. This object will be merged
// into the scope and later on avaliable as $scope.typographyButtonsState
const mapStateToThis = (state) => {
  const {
    appState,
    appState: {
      selectedTab = {},
      lockDetails = {},
      focusedFeature: { feature = {} } = {},
    },
  } = state
  return {
    // Typography buttons state. A UI will set `active` class for correspondent buttons
    typographyButtonsState: Object.assign({}, appState.typographyButtonsState),

    // Calculate whether Inline comments enabled or not.
    // A decision made based on ELEMENT_FOCUS_CHANGE handler data in appState reducer
    allowInlineComments:
      feature.type === 'blockquote' || feature.type === 'text',

    // Check for compose tab. Data comes from CHANGE_TAB handler from appState reducer
    isComposeTab: selectedTab.id === 'tab-compose',

    // Set isLockedOrReadonly when someone else holds a lock or story is readonly
    isLockedOrReadonly: !lockDetails.isMyLock || lockDetails.readonly,
  }
}

function Controller(
  $scope,
  $rootScope,
  tabService,
  $ngRedux,
  toastr,
  storyService
) {
  $scope.intl = intl

  // Connect redux to the controller instance, disconnect on scope destroy
  $scope.$on('$destroy', $ngRedux.connect(mapStateToThis)($scope))

  $scope.charMapOpts = charMapOpts
  $scope.typographyButtons = typographyButtons

  const bindings = {}
  $scope.typographyButtons.forEach((item) => {
    if (item.keyBinding) {
      item.keyBinding.forEach((pattern) => {
        bindings[pattern] = item.action
      })
    }
  })

  window.addEventListener('keydown', (evt) => {
    if (!isComposeTabActive()) {
      return
    }
    const pattern = []
    if (evt.metaKey) pattern.push('cmd')
    if (evt.ctrlKey) pattern.push('ctrl')
    if (evt.altKey) pattern.push('alt')
    pattern.push(evt.key || String.fromCharCode(evt.which))
    const action = bindings[pattern.join('+')]
    if (action) {
      $scope.performAction(evt, { action })
      evt.preventDefault()
      return false
    }
  })

  const positionCursorAndRemove = () => {
    const temp = $('.tempHolder')
    const cmElem = temp.closest('.CodeMirror')

    if (cmElem.length) {
      const cm = cmElem[0].CodeMirror
      const marks = cm
        .getAllMarks()
        .filter((elm) =>
          angular.element(elm.replacedWith).hasClass('tempHolder')
        )
      if (marks.length) {
        const pos = marks[0].find()
        pos.char += 2
        var txt = marks[0].replacedWith.parentNode.innerText
        marks[0].clear()
        cm.focus()
        cm.setCursor(pos)
        cm.replaceSelection(txt, 'end')
      }
    } else if (temp.length) placeCaretAfterNode(temp[0])
    temp.remove()
  }

  const caretPosition = (input) => {
    let iCaretPos = 0
    if (document.selection) {
      const oSel = document.selection.createRange()
      oSel.moveStart('character', -input.value.length)
      iCaretPos = oSel.text.length
    } else if (input.selectionStart) {
      iCaretPos = input.selectionStart
    }
    return iCaretPos
  }

  const pushUndoStack = (range) => {
    const selection = window.getSelection()
    // pushContentElementState destroy range internally. It should be saved and restored
    const clone = range.cloneRange()
    storyService.pushContentElementState()
    selection.removeAllRanges()
    selection.addRange(clone)
  }

  const insertPlaceholderElem = () => {
    let sel, range

    if (window.getSelection && (sel = window.getSelection()).rangeCount) {
      range = sel.getRangeAt(0)
      range.collapse(true)

      const ancElem = angular.element(range.commonAncestorContainer)
      const cmElem = ancElem.closest('.CodeMirror')
      const span = document.createElement('span')
      const activeElem = $(document.activeElement)

      span.classList.add('tempHolder')

      // Check if we have code mirror element or if we
      // have a content editable element so we can add
      // a placeholder so we can posiiton the dialog
      if (cmElem.length) {
        // Code Mirror
        const cm = cmElem[0].CodeMirror
        cm.setBookmark(cm.getCursor(), { widget: span })
      } else if (activeElem.is(':text') || activeElem.is('textarea')) {
        const pos =
          (activeElem[0].dataset && activeElem[0].dataset.se) ||
          caretPosition(activeElem[0])
        const $span = $(span)
        $span.insertAfter(activeElem)
        $span.data('input', activeElem[0])
        $span.data('insertPos', pos)
      } else if (ancElem.closest('[contenteditable="true"]').length) {
        // contenteditable
        range.insertNode(span)

        // Move the caret immediately after the inserted span
        range.setStartAfter(span)
        range.collapse(true)
        sel.removeAllRanges()
        sel.addRange(range)
      }
    }
  }

  const placeCaretAfterNode = (node) => {
    const range = document.createRange()
    range.setStartAfter(node)
    range.collapse(true)
    const selection = window.getSelection()
    selection.removeAllRanges()
    selection.addRange(range)
  }

  let tetherObj
  $scope.performAction = ($event, btn) => {
    if ($event) {
      $event.preventDefault()
      $event.stopPropagation()
    }
    const action = btn.action

    switch (action) {
      case 'inlineComment':
        const selection = window.getSelection()
        // I don't know if this is right
        const Node = document.createElement('dfn')
        const wrappingContainer = (container) =>
          container && container.nodeType === Node.TEXT_NODE
            ? wrappingContainer(container.parentNode)
            : container
        let range = selection.getRangeAt(0)
        range = normaliseSelectionRange(range) || range
        const startContainer = wrappingContainer(range.startContainer).closest(
          '[content-element]'
        )
        const endContainer = wrappingContainer(range.endContainer).closest(
          '[content-element]'
        )
        if (startContainer !== endContainer) {
          toastr.info(intl.get('typographyButtons.inlineComment.warning'))
          return
        }

        startContainer.classList.add('dirty')

        // Help revert recently added inline comment
        pushUndoStack(range)

        // Check typography feedback and revert inline comment if it in a DFN node
        if ($scope.typographyButtonsState.hasComment) {
          if (
            selection.anchorNode &&
            selection.anchorNode.parentNode &&
            selection.anchorNode.parentNode.nodeName === 'DFN'
          ) {
            $(selection.anchorNode).unwrap()
            selection.collapseToEnd()
          }
        } else {
          if (selection.type === 'Range') {
            const text = extractSelectedText(selection)
            const dfnNode = document.createElement('dfn')
            dfnNode.innerHTML = text
            insertNodeIntoCursorPosition(selection, dfnNode)
            selectNode(selection, dfnNode)
          } else {
            const node = createInlineCommentNode()
            insertNodeIntoCursorPosition(selection, node)
            selectNode(selection, node.childNodes[0])
          }
        }

        // TODO: This is just to get it working so TGAM is happy, need to find a better way to do this
        window.setTimeout(() => {
          const wrapperC = $(startContainer)
          const temp = wrapperC.clone()
          temp
            .find('[paste-options], dfn, .handles, .js-formatting-popover')
            .remove()

          $rootScope.$broadcast('DISPATCH', {
            type: constants.WORDCOUNT,
            orgIndex: wrapperC.data('org-index'),
            content: temp
              .text()
              .trim()
              .replace(/(&nbsp;|\s)+/g, ' '),
          })
        }, 10)

        break
      case 'createLink':
        // if there is no selection, than just ignore the click
        if (!window.getSelection().toString().length) {
          return false
        }
        // force url prompt first
        // const url = prompt('Enter a URL:', 'http://')
        // const text = document.getSelection()
        // document.execCommand('insertHTML', false, `<a href="http://blank.it">${text}</a>`)
        document.execCommand('createlink', false, '/TEMP-LINK-TEMP/')
        // add slight delay so dialog can work
        // TODO: Mike: have a better solution than this delayed hack
        window.setTimeout(() => {
          $(window.getSelection().baseNode).closest('a').click()
        }, 100)
        break
      case 'charmap':
        $scope.charMapVal = { value: null }
        insertPlaceholderElem()

        const tempPlaceholder = $('.tempHolder')

        // if we do not have a placeholder element,
        // means there is no active cursor so exit
        if (!tempPlaceholder.length) return

        // make sure we have something to tether to
        if (!$event) {
          return console.warn('Could not find charmap button')
        }

        const charElem = $('#charmap')
          .show()
          .removeAttr('hidden')
          .on('click', (evt) => {
            evt.stopPropagation()
          })

        /* eslint no-unused-vars: "off" */
        const tetherInstance = new Tether({
          element: charElem,
          target: $($event.target),
          attachment: 'top center',
          targetAttachment: 'bottom center',
          constraints: [
            {
              to: 'scrollParent',
              pin: true,
            },
            {
              to: 'window',
              attachment: 'together',
            },
          ],
        })

        charElem.addClass('show')
        const uiBind = () => {
          $(window).on('click.hideCharPopOver', (evt) => {
            if ($(evt.target).closest('[nav-actions]').length) {
              return
            }
            if (
              $(evt.target).closest(
                '[data-original-title="Character Map (ctrl+k or cmd+k)"]'
              ).length
            ) {
              return
            }
            removePlaceholder()
          })

          $('#story-wrapper')
            .find('[content-element]')
            .on('click.CharPopOver', removePlaceholder)
        }
        window.setTimeout(uiBind, 0) // bind after this event stack
        break
      case 'removeFormat,unlink':
        const removeFormatActions = action.split(/\s?,\s?/)
        removeFormatActions.forEach((cmd) => document.execCommand(cmd))

        window.setTimeout(() => {
          $rootScope.$broadcast('DISPATCH', {
            type: constants.WORDCOUNT,
          })
        }, 10)

        break
      default:
        // actions can be simple or multiple now separated by a comma
        const actions = action.split(/\s?,\s?/)
        actions.forEach((cmd) => document.execCommand(cmd))
    }
  }

  $scope.charMapVal = { value: null }
  $scope.replacePlaceholder = (model) => {
    const tempHolder = $('.tempHolder')
    const input = tempHolder.data('input')

    // If textbox
    if (input) {
      const text = $('<div></div>').html(model.value).text()
      const pos = tempHolder.data('insertPos') || 0
      const val = input.value
      input.value = val.substr(0, pos) + text + val.substr(pos)
      tempHolder.remove()
      input.focus()
      input.setSelectionRange(pos + 1, pos + 1)
      angular.element(input).triggerHandler('input') // trigger for angular model update
    } else {
      // content editable
      tempHolder.before(model.value)
      // update that there was a change so it will save
      tempHolder.closest('[contenteditable]').trigger('change input')
      tempHolder.closest('.feature-focused').addClass('dirty')
      if (tempHolder) {
        positionCursorAndRemove()
      }
    }
    hideCharPopOver()
  }

  const isComposeTabActive = () => {
    if ($scope.isComposeTab === undefined) {
      $scope.isComposeTab = tabService.get() === 'tab-compose'
    }
    return $scope.isComposeTab
  }

  $scope.removePlaceholder = () => {
    positionCursorAndRemove()
    hideCharPopOver()
  }
  var removePlaceholder = $scope.removePlaceholder

  // CHROME not allowing us to get cursor so need to record it
  $(window).on('keyup click focus input_click', (e, oEvt) => {
    e = e.type === 'input_click' ? oEvt : e
    if (
      isComposeTabActive() &&
      (e.target.nodeName === 'TEXTAREA' ||
        (e.target.nodeName === 'INPUT' && e.target.type === 'text'))
    ) {
      e.target.dataset.se = e.target.selectionStart
    }
  })

  function hideCharPopOver() {
    $('#charmap')
      .removeClass('show')
      .off('click')
      .css({ top: 0, left: 0 })
      .hide()
    $(window).off('click.hideCharPopOver')
    $('#story-wrapper').find('[content-element]').off('click.CharPopOver')
  }

  $scope.hasActiveState = (flag) =>
    !!($scope.typographyButtonsState.flag & flag)

  $scope.isDisabled = (button) => {
    if ($scope.isLockedOrReadonly) {
      return true
    }

    if (button.action !== 'inlineComment') {
      return false
    }
    return !$scope.allowInlineComments
  }
}
